import React from 'react';

const SvgUa = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="UA_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="UA_svg__b" fill="#fff">
        <use xlinkHref="#UA_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#UA_svg__a" />
      <path fill="#156DD1" mask="url(#UA_svg__b)" d="M0 0h28v10.667H0z" />
      <path fill="#FFD948" mask="url(#UA_svg__b)" d="M0 10.667h28V20H0z" />
    </g>
  </svg>
);

export default SvgUa;
